/**
 * cropLabel — единый способ получить человекочитаемое имя культуры из
 * ответа reference-эндпоинта `/api/v1/reference/crops`.
 *
 * Проблема (AK-336): endpoint отдаёт локализованное имя в
 * `name_translations.ru` (+ `latin_name` / `code`), а НЕ в плоском `name_ru`.
 * Дропдаун в /fields/new читал `name_ru ?? name ?? String(id)` → показывал
 * UUID культуры. AddFieldPanel (tap-to-field) уже читал правильно; выносим
 * общий хелпер, чтобы не расходиться.
 *
 * Precedence: name_translations.ru → latin_name → code → name → name_ru → id.
 * (`name`/`name_ru` оставлены как хвостовые фолбэки для legacy-форматов.)
 */

export interface CropLike {
  id: number | string;
  name_translations?: { ru?: string | null; en?: string | null } | null;
  latin_name?: string | null;
  code?: string | null;
  /** Legacy-поля некоторых эндпоинтов; используются только как фолбэк. */
  name?: string | null;
  name_ru?: string | null;
}

export function cropLabel(c: CropLike): string {
  return (
    c.name_translations?.ru ??
    c.latin_name ??
    c.code ??
    c.name ??
    c.name_ru ??
    String(c.id)
  );
}
